/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Grid from '@mui/material/Unstable_Grid2';
import moment from 'moment';
import _, { filter } from 'lodash';
import { toast } from 'react-toastify';
import {
  getTeamV4Filter,
  getManagerFilter,
  getRepFilter,
  getGroupFilter,
  getDoctorFilter,
} from '../../../api/filterOptionsApi';
// Helpers
import {
  filterValue,
  filterTeamV4Options,
  filterManagerOptions,
  filterRepOptions,
  filterGroupOptions,
  filterDoctorv2Options,
} from '../../../helpers/filterFunctions';
import useStore from '../../../states/store';
import { useMdProfileContext } from '../context/useMdProfileContext';

function Filter() {
  const { filterForm, handleChangeFilter, handleGenerateReport, handleClearReport } =
    useContext(useMdProfileContext);

  const auth = useStore((state) => state.auth);

  const managerView = ['KASM', 'KASROM', 'KASOM', 'SAM', 'RSM'];

  const [teamOptions, setTeamOptions] = useState({ loading: false, data: [] });
  const [managerOptions, setManagerOptions] = useState({ loading: false, data: [] });
  const [repOptions, setRepOptions] = useState({ loading: false, data: [] });
  const [groupOptions, setGroupOptions] = useState({ loading: false, data: [] });
  const [mdOptions, setMdOptions] = useState({ loading: false, data: [] });

  const loadTeamDropdown = async () => {
    setTeamOptions({ loading: true, data: [] });
    const request = {
      manager_id: filterValue(filterForm?.manager_id),
      rep_id: filterValue(filterForm?.rep_id),
      group: filterValue(filterForm?.group),
      md_id: filterValue(filterForm?.doctor_id),
    };
    const reponse = await getTeamV4Filter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterTeamV4Options(data);
      setTeamOptions({
        ...teamOptions,
        loading: false,
        data: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };

  const loadManagersDropdown = async () => {
    setManagerOptions({ loading: true, data: [] });
    const request = {
      rep_team: filterValue(filterForm?.team),
      rep_id: filterValue(filterForm?.rep_id),
      group: filterValue(filterForm?.group),
      md_id: filterValue(filterForm?.doctor_id),
    };
    const response = await getManagerFilter(request);
    const { code, data } = response.data;

    if (code === '200') {
      const dropdownValue = filterManagerOptions(data);
      setManagerOptions({
        ...managerOptions,
        loading: false,
        data: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };

  const loadRepDropdown = async () => {
    setRepOptions({ loading: true, data: [] });
    const request = {
      rep_team: filterValue(filterForm?.team),
      manager_id: filterValue(filterForm?.manager_id),
      group: filterValue(filterForm?.group),
      md_id: filterValue(filterForm?.doctor_id),
    };
    const reponse = await getRepFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterRepOptions(data);

      setRepOptions({
        ...repOptions,
        loading: false,
        data: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };

  const loadGroupDropdown = async () => {
    setGroupOptions({ loading: true, data: [] });
    const request = {
      rep_team: filterValue(filterForm?.team),
      manager_id: filterValue(filterForm?.manager_id),
      rep_id: filterValue(filterForm?.rep_id),
      md_id: filterValue(filterForm?.doctor_id),
    };
    const reponse = await getGroupFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterGroupOptions(data);

      setGroupOptions({
        ...groupOptions,
        loading: false,
        data: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };

  const loadMDDropdown = async () => {
    setMdOptions({ loading: true, data: [] });
    const request = {
      rep_team: filterValue(filterForm?.team),
      manager_id: filterValue(filterForm?.manager_id),
      rep_id: filterValue(filterForm?.rep_id),
      group: filterValue(filterForm?.group),
    };
    const response = await getDoctorFilter(request);
    const { code, data } = response.data;

    if (code === '200') {
      const dropdownValue = filterDoctorv2Options(data);
      setMdOptions({
        ...mdOptions,
        loading: false,
        data: [{ label: 'ALL', value: null }, ...dropdownValue],
      });
    }
  };

  useEffect(() => {
    loadTeamDropdown();
    loadManagersDropdown();
    loadRepDropdown();
    loadGroupDropdown();
    loadMDDropdown();
  }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={1}>
        {!managerView.includes(auth?.designation) ? (
          <>
            <Grid md={2}>
              <Autocomplete
                disablePortal
                id='team'
                disableClearable
                fullWidth
                loading={teamOptions.loading}
                options={teamOptions.data}
                // eslint-disable-next-line react/jsx-props-no-spreading
                renderInput={(params) => <TextField {...params} label='Team' />}
                size='small'
                value={filterForm?.team}
                onChange={(e, newValue) => handleChangeFilter(e, newValue, 'team')}
                sx={{ backgroundColor: '#fff' }}
              />
            </Grid>

            <Grid md={2}>
              <Autocomplete
                disablePortal
                id='manager_id'
                disableClearable
                fullWidth
                loading={managerOptions.loading}
                options={managerOptions.data}
                // eslint-disable-next-line react/jsx-props-no-spreading
                renderInput={(params) => <TextField {...params} label='Manager (KASM/SAM)' />}
                size='small'
                value={filterForm?.manager_id}
                onChange={(e, newValue) => handleChangeFilter(e, newValue, 'manager_id')}
                sx={{ backgroundColor: '#fff' }}
              />
            </Grid>
          </>
        ) : (
          ''
        )}

        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='rep_id'
            disableClearable
            fullWidth
            loading={repOptions.loading}
            options={repOptions.data}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='KASS/SAR' />}
            size='small'
            value={filterForm?.rep_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'rep_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>

        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='group'
            disableClearable
            fullWidth
            loading={groupOptions.loading}
            options={groupOptions.data}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Group' />}
            size='small'
            value={filterForm?.group}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'group')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='doctor_id'
            disableClearable
            fullWidth
            loading={mdOptions.loading}
            options={mdOptions.data}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='MD' />}
            size='small'
            value={filterForm?.doctor_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'doctor_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={handleGenerateReport}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={handleClearReport}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Filter;
